import type { TenantConfig } from '@/types/TenantConfig'

export const seismique: TenantConfig = {
  themeMode: 'dark',
  themeOptions: {
    dialog: {
      headerBackground: '#1F1F1F',
      backgroundColor: '#000000',
      headerBorder: '1px solid rgba(255, 255, 255, 0.15)',
    },
    mobileFooter: {
      backgroundColor: '#1F1F1F',
      cartButtonBackgroundColor: 'transparent',
      cartButtonHoverBackgroundColor: 'transparent',
    },
    backButton: {
      backgroundColor: '#4dd3ff',
    },
  },
  logo: 'assets/seismique/static/logo.png',
  teaserImageSize: {
    height: 208,
  },
  titleInsideContentColumn: true,
  componentOptions: {
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/seismique/static/completed.jpg',
      },
      completedContentOffset: {
        desktop: '-200px',
        mobile: '-150px',
      },
    },
    stripeCreditCard: {
      fontFaceStylesheet:
        'https://fonts.googleapis.com/css2?family=Luckiest+Guy&family=Open+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap',
    },
  },
  i18nOverrides: {
    en: {
      cartWidget: {
        percentFees: 'Taxes and Fees',
      },
    },
  },
}
